import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { PortadaComponent } from './secciones/portada/portada.component';
import { BarraNavegacionComponent } from './secciones/barra-navegacion/barra-navegacion.component';
import { CartaImgIzqComponent } from './secciones/compartido/carta-img-izq/carta-img-izq.component';
import { CartaImgArrbComponent } from './secciones/compartido/carta-img-arrb/carta-img-arrb.component';
import { QuienesSomosComponent } from './secciones/quienes-somos/quienes-somos.component';
import { TituloDescripcionComponent } from './secciones/compartido/titulo-descripcion/titulo-descripcion.component';
import { PrimerSeparadorComponent } from './secciones/primer-separador/primer-separador.component';
import { NuestraHistoriaComponent } from './secciones/nuestra-historia/nuestra-historia.component';
import { LineaTemporalComponent } from './secciones/compartido/linea-temporal/linea-temporal.component';
import { SegundoSeparadorComponent } from './secciones/segundo-separador/segundo-separador.component';
import { NuestroTrabajoComponent } from './secciones/nuestro-trabajo/nuestro-trabajo.component';
import { IvyCarouselModule } from 'angular-responsive-carousel';
import { TercerSeparadorComponent } from './secciones/tercer-separador/tercer-separador.component';
import { AyudaComponent } from './secciones/ayuda/ayuda.component';
import { ModalModule } from 'ngx-bootstrap/modal';
import { CuartoSeparadorComponent } from './secciones/cuarto-separador/cuarto-separador.component';
import { ContactoComponent } from './secciones/contacto/contacto.component';
import { FormularioComponent } from './secciones/compartido/formulario/formulario.component';
import { ReactiveFormsModule } from '@angular/forms';
import { PiePaginaComponent } from './secciones/pie-pagina/pie-pagina.component';
import { HttpClientModule } from '@angular/common/http';



@NgModule({
  declarations: [
    AppComponent,
    PortadaComponent,
    BarraNavegacionComponent,
    CartaImgIzqComponent,
    CartaImgArrbComponent,
    QuienesSomosComponent,
    TituloDescripcionComponent,
    PrimerSeparadorComponent,
    NuestraHistoriaComponent,
    LineaTemporalComponent,
    SegundoSeparadorComponent,
    NuestroTrabajoComponent,
    TercerSeparadorComponent,
    AyudaComponent,
    CuartoSeparadorComponent,
    ContactoComponent,
    FormularioComponent,
    PiePaginaComponent,
  ],
  imports: [
    BrowserModule,
    IvyCarouselModule,
    ModalModule.forRoot(),
    ReactiveFormsModule,
    HttpClientModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
